__turbopack_context__.v({
  "accordionSlideOverwrite": "faqPageSidebar-module-scss-module__d84VPq__accordionSlideOverwrite",
  "fadeIn": "faqPageSidebar-module-scss-module__d84VPq__fadeIn",
  "fadeOut": "faqPageSidebar-module-scss-module__d84VPq__fadeOut",
  "link": "faqPageSidebar-module-scss-module__d84VPq__link",
  "linkActive": "faqPageSidebar-module-scss-module__d84VPq__linkActive",
  "list": "faqPageSidebar-module-scss-module__d84VPq__list",
  "listItem": "faqPageSidebar-module-scss-module__d84VPq__listItem",
  "scaleIn": "faqPageSidebar-module-scss-module__d84VPq__scaleIn",
  "scaleOut": "faqPageSidebar-module-scss-module__d84VPq__scaleOut",
  "sidebar": "faqPageSidebar-module-scss-module__d84VPq__sidebar",
  "zoomIn": "faqPageSidebar-module-scss-module__d84VPq__zoomIn",
  "zoomOut": "faqPageSidebar-module-scss-module__d84VPq__zoomOut",
});
